import type { ReactNode } from 'react';

import { cn } from '@/shared/lib/cn';
import { Label } from '@/shared/ui/label';

/**
 * Rótulo + controle + erro de campo.
 *
 * Promovido de dentro de `RegistroPage.tsx`, onde era privado — e o
 * `LoginPage.tsx` duplicava o mesmo markup inline. Com 6 telas de CRUD pela
 * frente, a terceira cópia sairia de graça e a divergência também.
 */
export function Campo({
  id,
  rotulo,
  erro,
  dica,
  obrigatorio,
  children,
  className,
}: {
  id: string;
  rotulo: string;
  erro?: string;
  /** Texto de apoio abaixo do controle. Some quando há erro. */
  dica?: string;
  obrigatorio?: boolean;
  children: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn('space-y-2', className)}>
      <Label htmlFor={id} className="text-brand font-medium">
        {rotulo}
        {obrigatorio && (
          <span className="text-destructive ml-0.5" aria-hidden="true">
            *
          </span>
        )}
      </Label>

      {children}

      {erro ? (
        <p className="text-xs text-destructive">{erro}</p>
      ) : (
        dica && <p className="text-xs text-muted-foreground">{dica}</p>
      )}
    </div>
  );
}

/**
 * Classe padrão dos controles dentro de `<Campo>`.
 *
 * Estava duplicada como `const CAMPO` no `LoginPage` e no `RegistroPage`.
 */
export const CLASSE_CONTROLE =
  'bg-surface-raised border-brand/30 focus:border-brand focus:ring-brand/20 placeholder:text-muted-foreground';
